import React, { useState } from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import WelcomePage from './components/WelcomePage';
import Step1 from './components/Step1';
import Step2 from './components/Step2';
import Step3 from './components/Step3';
import Step4 from './components/Step4';
import ResultsPage from './components/ResultsPage';
import Navigation from './components/Navigation';
import ProgressBar from './components/ProgressBar';
import './App.css';

function App() {
  const [formData, setFormData] = useState({
    bookMessage: '',
    bookReader: '',
    bookTransformation: '',
    launchGoal: '',
    launchMetrics: '',
    timeline: '',
    contentStyle: '',
    authorStrengths: '',
    chosenChannels: [],
    chosenAdPlatform: '',
    firstStep: ''
  });

  const [currentStep, setCurrentStep] = useState(0);

  const updateFormData = (newData) => {
    setFormData(prev => ({ ...prev, ...newData }));
  };

  const nextStep = () => {
    setCurrentStep(prev => Math.min(prev + 1, 5));
  };

  const prevStep = () => {
    setCurrentStep(prev => Math.max(prev - 1, 0));
  };

  return (
    <Router>
      <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-orange-50">
        <div className="container mx-auto px-4 py-8 max-w-4xl">
          <AnimatePresence mode="wait">
            {currentStep === 0 && (
              <motion.div
                key="welcome"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -20 }}
                transition={{ duration: 0.5 }}
              >
                <WelcomePage onStart={nextStep} />
              </motion.div>
            )}

            {currentStep === 1 && (
              <motion.div
                key="step1"
                initial={{ opacity: 0, x: 50 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: -50 }}
                transition={{ duration: 0.5 }}
              >
                <ProgressBar currentStep={1} totalSteps={4} />
                <Step1 
                  formData={formData}
                  updateFormData={updateFormData}
                  onNext={nextStep}
                  onPrev={prevStep}
                />
              </motion.div>
            )}

            {currentStep === 2 && (
              <motion.div
                key="step2"
                initial={{ opacity: 0, x: 50 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: -50 }}
                transition={{ duration: 0.5 }}
              >
                <ProgressBar currentStep={2} totalSteps={4} />
                <Step2 
                  formData={formData}
                  updateFormData={updateFormData}
                  onNext={nextStep}
                  onPrev={prevStep}
                />
              </motion.div>
            )}

            {currentStep === 3 && (
              <motion.div
                key="step3"
                initial={{ opacity: 0, x: 50 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: -50 }}
                transition={{ duration: 0.5 }}
              >
                <ProgressBar currentStep={3} totalSteps={4} />
                <Step3 
                  formData={formData}
                  updateFormData={updateFormData}
                  onNext={nextStep}
                  onPrev={prevStep}
                />
              </motion.div>
            )}

            {currentStep === 4 && (
              <motion.div
                key="step4"
                initial={{ opacity: 0, x: 50 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: -50 }}
                transition={{ duration: 0.5 }}
              >
                <ProgressBar currentStep={4} totalSteps={4} />
                <Step4 
                  formData={formData}
                  updateFormData={updateFormData}
                  onNext={nextStep}
                  onPrev={prevStep}
                />
              </motion.div>
            )}

            {currentStep === 5 && (
              <motion.div
                key="results"
                initial={{ opacity: 0, scale: 0.95 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.95 }}
                transition={{ duration: 0.5 }}
              >
                <ResultsPage 
                  formData={formData}
                  onRestart={() => {
                    setCurrentStep(0);
                    setFormData({
                      bookMessage: '',
                      bookReader: '',
                      bookTransformation: '',
                      launchGoal: '',
                      launchMetrics: '',
                      timeline: '',
                      contentStyle: '',
                      authorStrengths: '',
                      chosenChannels: [],
                      chosenAdPlatform: '',
                      firstStep: ''
                    });
                  }}
                />
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      </div>
    </Router>
  );
}

export default App;